export default "__VITE_ASSET__Bk57fYju__"